const walletConnect = '0cd36c2c686d553aa8ee011729c9ce03'

export { walletConnect }